import { TherapistAction } from '../../../src/redux/actions/constant';

export const therapistDialogAssignTaskAction = (payload: any) => {
    return {
        type: TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_REQUEST,
        payload,
    };
};

export const resetTherapistAssignDataAction = () => {
    return {
        type: TherapistAction.THERAPIST_DIALOG_ASSIGN_TASK_RESET,
    };
};
